export default __webpack_public_path__ + "static/media/sewing_pattern.d103d748.jpeg";